import type { Entries } from "../../pojo/Util";
import { shallowSort } from "./s25.shallow.sort";

export namespace S25Object {
    export function fromEntries<Key extends string | number, T>(entries: [Key, T][]): Record<Key, T> {
        const obj = {} as Record<Key, T>;
        for (const [key, value] of entries) obj[key] = value;
        return obj;
    }

    export function clear(obj: any) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) delete obj[key];
        }
        return obj;
    }

    export function reverse<T extends Record<string, S>, S extends PropertyKey>(obj: T) {
        const reversed = {} as any;
        for (const [key, val] of Object.entries(obj)) {
            reversed[val] = key;
        }
        return reversed as { [K in keyof T as T[K]]: K };
    }

    export function* values<T extends {}>(obj: T) {
        for (const key in obj) {
            if (!obj.hasOwnProperty(key)) continue;
            yield obj[key];
        }
    }

    export function safeValues<T>(obj: { [s: string]: T } | ArrayLike<T>): T[] {
        if (!obj) return [];
        return Object.values(obj);
    }

    export function keys<T extends object>(obj: T): (keyof T)[] {
        return Object.keys(obj) as (keyof T)[];
    }

    export function entries<T extends object>(obj: T): Entries<T> {
        return Object.entries(obj) as Entries<T>;
    }

    export function extend(target: any, ...sources: any): any {
        return Object.assign(target, ...sources);
    }

    export function propertyListToArray(obj: any, justPropValue?: boolean, propName?: string): any[] {
        const ret: any[] = [];
        if (obj) {
            for (const prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (prop) {
                        if (justPropValue) {
                            if (obj[prop]) {
                                const value: any = propName ? obj[prop][propName] : obj[prop];
                                ret.push(value);
                            }
                        } else {
                            ret.push({ value: obj[prop], prop: prop });
                        }
                    }
                }
            }
        }

        return ret.sort(shallowSort("prop"));
    }
}
